import React, {useRef, useState} from "react";
import {Col, Row} from "react-bootstrap";
import BootstrapTable from "react-bootstrap/Table";
import TableTopBar from "../../components/tables/top/TableTopBar";
import Pagination from "../../components/common/Pagination";
import AxcBadge from "../../components/common/AxcBadge";
import {getCtlRPTListAll} from "../../api/apiClient";
import Swal from "sweetalert2";
import Moment from "moment";
import {exportExcel} from "../../common/exportExcel";
import {exportPdf} from "../../common/exportPdf";
import usePdf from "../../hook/usePdf";

const TableCtlRPT = ({
                       currentPage,
                       setCurrentPage,
                       listPageSize,
                       setListPageSize,
                       total,
                       tableList,
                       getFullData = null,
                       setIsSearch,
                       updateList,
                       setTableList,
                       setTotal,
                       searchParam
                     }) => {

  // select ////////////////////////////////////
  const updatePageSize = (aSize) => {
    setIsSearch(true);
    setCurrentPage(1);
    setListPageSize(parseInt(aSize));
  };

  const tableRef = useRef(null);
  const [isExport, setIsExport] = useState(false);

  const onDownload = () => {
    exportExcel(tableRef, "제어이력-중계기_.xls")
  }


  const getAllList = () => {
    setIsExport(true);
    getCtlRPTListAll(
        currentPage, listPageSize,
        searchParam.searchCtrlTy,
        searchParam.searchFcltyNo,
        Moment(searchParam.startDate).format('YYYY-MM-DD'),
        searchParam.searchRpeatNo,
        Moment(searchParam.endDate).format('YYYY-MM-DD'),
        searchParam.startHour,
        searchParam.endHour)
        .then((res) => {
              // console.log(res);
              if (res.data.data !== undefined) {
                setTableList(res.data.data.list);
                setTotal(res.data.data.total);
              }
            }
        );
  };

  const downloadExcelToTable = () => {
    getAllList();

    Swal.fire({
      title: `EXCEL 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
      }
      setIsExport(false);
      updateList();
    })
  };

  const exportReport = () => {
    getAllList();

    Swal.fire({
      title: `PDF 다운로드 하시겠습니까?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `확인`,
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
          exportPdf(tableRef, '제어이력_중계기.pdf');
      }
      setIsExport(false);
      updateList();
    });
  };


  return (
      <>
        <Row>
          <Col md={6} className={""}>
            <TableTopBar
                propSelectOption={{
                  isEnable: true,
                  selItems: [15, 30, 50], //미구현
                  setFunc: updatePageSize,
                }}
                propExcelExport={{
                  isEnable: true,
                  exportFilename: 'doc.xlsx',
                  getFunc: getFullData,
                }}
                propExcelDownload={{
                  isEnable: true,
                  getFunc: downloadExcelToTable,
                }}
                /*propPdfExport={{
                  isEnable: true,
                  // exportFilename: 'doc.pdf',
                  getFunc: exportReport,
                }}*/
                propPdf={{
                  isEnable: true,
                  getFunc: usePdf({
                    tableRef: tableRef,
                    setIsExport: setIsExport,
                    getAllList: getAllList,
                    updateList: updateList,
                    filename: '제어이력-중계기',
                  }),
                }}
                // propDelete = {{
                //     isEnable: false,
                //     delFunc: null,
                // }}
                // propReg = {{
                //     isEnable: false,
                //     regFunc: null,
                // }}
                // propControl = {{
                //     isEnable: true,
                //     ctlFunc: null,
                // }}
            />
          </Col>

          <Col md={12}>
            <div className={"table-responsive text-nowrap"}>
              <BootstrapTable hover className={"table "} ref={tableRef}>
                <thead className={"table-head text-secondary"}>
                <tr className={""}>
                  <th className={"col-md-2"}>제어시간</th>
                  <th className={"col-md-1"}>시설명</th>
                  <th className={"col"}>층정보</th>
                  <th className={"col"}>중계기명</th>
                  <th className={"col"}>게이트웨이ID</th>
                  <th className={"col"}>중계기ID</th>
                  <th className={"col"}>제어유형</th>
                  <th className={"col"}>설정값</th>
                  <th className={"col"}>처리상태</th>
                  <th className={"col"}>실패원인</th>
                  <th className={"col"}>등록자</th>
                </tr>
                </thead>
                <tbody className={`table-body text-start ${isExport ? "" : "text-white"} `}>
                {
                  Array.isArray(tableList) ?
                      (tableList.map((elem, idx) => {
                        return <tr key={idx}>
                          <td>{elem.prcs_dt_str}</td>
                          <td>{elem.fclty_nm}</td>
                          <td>{elem.fclty_dtl_nm}</td>
                          <td>{elem.rpeat_lc_nm}</td>
                          <td>{elem.gtwy_id}</td>
                          <td>{elem.rpeat_id}</td>
                          <td>{elem.ctrl_ty_nm}</td>
                          <td>{elem.paramtr}</td>
                          <td><AxcBadge propInput={elem.prcs_sttus_nm}
                                        propSuccessText={'성공'}
                                        propWarningText={'처리중'}
                          /></td>
                          <td>{elem.rspns_nm}</td>
                          <td>{elem.user_info}</td>
                        </tr>;
                      })) :
                      ('')
                }

                </tbody>
              </BootstrapTable>
            </div>
          </Col>
          <Col className={"my-2"}>
            <Pagination
                propCurPage={currentPage}
                propTotal={total}
                propPageSize={listPageSize}
                propSetNewPage={setCurrentPage}
                propSetIsSearch={setIsSearch}
            />
          </Col>
        </Row>
      </>
  );
};


export default TableCtlRPT;
